import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

const getDeliveryTracking = async (invoiceNo) => {
  const endpoint = `/admin/delivery-orders/${invoiceNo}`;
  const result = await http(endpoint);
  return result.data;
};

export function useDeliveryTracking(invoiceNo) {
  return useQuery({
    queryKey: ["delivery-tracking", invoiceNo],
    queryFn: () => getDeliveryTracking(invoiceNo),
    enabled: !!invoiceNo,
  });
}
